/**
 * Represents the zeus.apollon_fk_conf.conf value object - the Foerderkategorie config
 * json structure
 *
 * This file is part of Zeus Apollon
 *
 * (c) Kaden und Partner AG
 */
import { createModel, Model, type MutationsObject } from '@kp/js-model';
import { Kontakte } from '@/models/apollon_conf_fk/Kontakte';
import { Projekt } from '@/models/apollon_conf_fk/Projekt';
import { Objekte } from '@/models/apollon_conf_fk/Objekte';
import { Dokumente } from '@/models/apollon_conf_fk/Dokumente';

export class Config extends Model {
    public kontakte: Kontakte | null = null;
    public objekte: Objekte | null = null;
    public projekt: Projekt | null = null;
    public dokumente: Dokumente | null = null;

    public mutations(): MutationsObject {
        return {
            kontakte: (val: Kontakte) => createModel(Kontakte, val),
            objekte: (val: Objekte) => createModel(Objekte, val),
            projekt: (val: Projekt) => createModel(Projekt, val),
            dokumente: (val: Dokumente) => createModel(Dokumente, val)
        };
    }
}
